 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		27: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		27: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"777cf710","1":"95b64a6e","2":"commons","3":"dbf3ce33","4":"styles","5":"7500e8553228f5b0b9c24324cb23c0e7a2582721","6":"357390fd66a7102f9561d1bcb9b270695f141512","7":"95c8edcd9666b13732141ad7dcd50cb9008a4794","8":"b7d7fd24ae0567d70a9035a6732098c8c89bf352","9":"6950eddd8b912213fc74eeb016485ceca4abea22","10":"c2f8d81661dc5d8f3a407327cd10b6cb478dd0cf","11":"c46f96cdd49c5254754c4769a8cbe97f1704c216","12":"d7eeaac4","13":"15bbc6a7","14":"1bfc9850","15":"252f366e","16":"4e885b7f1bf795bb8dceeda06eb85a46d135a717","17":"4fdbb7d8654883ce3f167f88caaffd7c14d477dd","18":"506fe362900cb0429a5f7e922ee0b3ce6819ce27","19":"537ef98cdccf83a77d8360d84e7b65aa26dd533c","20":"5c539c22","21":"ac1c44fc","22":"1a5fb981c7251f7ef45f63b6928b3ea4e331db05","23":"545f34e4","24":"5e2a4920","25":"7387268b","26":"ae51ba48","29":"210e6083","30":"2852872c","31":"84c042bb","32":"a4005603","34":"component---src-pages-404-tsx","35":"component---src-pages-agb-tsx","36":"component---src-pages-auth-callback-tsx","37":"component---src-pages-booking-auth-tsx","38":"component---src-pages-booking-success-tsx","39":"component---src-pages-bookings-tsx","40":"component---src-pages-breakfast-tsx","41":"component---src-pages-buchen-tsx","42":"component---src-pages-data-privacy-tsx","43":"component---src-pages-datenschutz-tsx","44":"component---src-pages-email-verification-success-tsx","45":"component---src-pages-extras-tsx","46":"component---src-pages-impressum-tsx","47":"component---src-pages-index-tsx","48":"component---src-pages-interior-tsx","49":"component---src-pages-kontakt-tsx","50":"component---src-pages-lage-tsx","51":"component---src-pages-login-tsx","52":"component---src-pages-save-vilhelm-7-tsx","53":"component---src-pages-user-tsx","54":"component---src-pages-voucher-success-tsx","55":"component---src-pages-wohnen-tsx","56":"component---src-templates-page-tsx","57":"f9fff01a"}[chunkId]||chunkId) + "-" + {"0":"48ebde556f03ade9731c","1":"b4638366a3a4df20b931","2":"276f11de6a5185f74440","3":"5bc10969c1fda8fbe575","4":"08bc34de4ea872a98d93","5":"9757f86710708bde9544","6":"e497e1350addf3e98c92","7":"01d48ffd3a5d98157382","8":"44da6cbfdcb26b7a5b93","9":"d4bf7d928a27fde021d9","10":"8ad6f6207e2a83b6217d","11":"c514bf81043d94d2a844","12":"f856c32878dba3a635c1","13":"ba05a861b0ab1e54a8e1","14":"e327eb9617c7f8190ec1","15":"832c2e7313596f751586","16":"e3ad78e786dbf167cfe0","17":"21622d2d691ea423d20e","18":"108ce0f8d1c383a7bd75","19":"f9f12fa78d1fbe01d87d","20":"1e62b6755ab1578937b2","21":"6eeff3e3534438fc3a2a","22":"36ed278a38df2b3aca54","23":"34a2c5e163f8c308b503","24":"371462b028aa9324542c","25":"f7c5b24b8ce43f4eb6a6","26":"94939e1af5580aed5451","28":"749f99119fc601d2268b","29":"0677c8f41d364b5427c0","30":"7170189d2f342bdb1c86","31":"d91abe59a5961fd2a82b","32":"ed8c5b6c0ed798bc8b4a","34":"7f7607e4cabe5022937d","35":"36be1295e868a90a3677","36":"06669fd518e2dd664e55","37":"dc0efbaffadffb8656ab","38":"49ed174027aa862052ad","39":"059694d4948fc3d2c1fa","40":"757a7e5138a4b62d6945","41":"7939466269de8fd734dc","42":"9715858dfca7751c5e19","43":"64a0eaa73ce4a1dce971","44":"4a8f02967ca4fac7671a","45":"da89ce15451c7a6b7e38","46":"f83573c6694f062a6c07","47":"f86b21dc4323cfb882e7","48":"5f12cffd7ee60ffc2032","49":"4cbcc3415fe1a6897270","50":"8a60586c665f7432abfb","51":"3fd32ef7c418d0e75b61","52":"14dfa2469feb453dd96e","53":"dea8730d45e0225ee776","54":"2eaff4278496b8eb6938","55":"36ed672f4c3440b20097","56":"9d18dce762fe9ac76598","57":"2bb08a0ef155c7bf007a","60":"efc49edae03ccb4f8b81","61":"c0ae0cecfa242898460a","62":"d81df40f031d5aebe2d0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"777cf710","1":"95b64a6e","2":"commons","3":"dbf3ce33","4":"styles","5":"7500e8553228f5b0b9c24324cb23c0e7a2582721","6":"357390fd66a7102f9561d1bcb9b270695f141512","7":"95c8edcd9666b13732141ad7dcd50cb9008a4794","8":"b7d7fd24ae0567d70a9035a6732098c8c89bf352","9":"6950eddd8b912213fc74eeb016485ceca4abea22","10":"c2f8d81661dc5d8f3a407327cd10b6cb478dd0cf","11":"c46f96cdd49c5254754c4769a8cbe97f1704c216","12":"d7eeaac4","13":"15bbc6a7","14":"1bfc9850","15":"252f366e","16":"4e885b7f1bf795bb8dceeda06eb85a46d135a717","17":"4fdbb7d8654883ce3f167f88caaffd7c14d477dd","18":"506fe362900cb0429a5f7e922ee0b3ce6819ce27","19":"537ef98cdccf83a77d8360d84e7b65aa26dd533c","20":"5c539c22","21":"ac1c44fc","22":"1a5fb981c7251f7ef45f63b6928b3ea4e331db05","23":"545f34e4","24":"5e2a4920","25":"7387268b","26":"ae51ba48","29":"210e6083","30":"2852872c","31":"84c042bb","32":"a4005603","34":"component---src-pages-404-tsx","35":"component---src-pages-agb-tsx","36":"component---src-pages-auth-callback-tsx","37":"component---src-pages-booking-auth-tsx","38":"component---src-pages-booking-success-tsx","39":"component---src-pages-bookings-tsx","40":"component---src-pages-breakfast-tsx","41":"component---src-pages-buchen-tsx","42":"component---src-pages-data-privacy-tsx","43":"component---src-pages-datenschutz-tsx","44":"component---src-pages-email-verification-success-tsx","45":"component---src-pages-extras-tsx","46":"component---src-pages-impressum-tsx","47":"component---src-pages-index-tsx","48":"component---src-pages-interior-tsx","49":"component---src-pages-kontakt-tsx","50":"component---src-pages-lage-tsx","51":"component---src-pages-login-tsx","52":"component---src-pages-save-vilhelm-7-tsx","53":"component---src-pages-user-tsx","54":"component---src-pages-voucher-success-tsx","55":"component---src-pages-wohnen-tsx","56":"component---src-templates-page-tsx","57":"f9fff01a"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"76ca1274a662eba64cc0","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
